namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DialogAdmFunkcniMistoSpisovyUzel extends GContentBase {
        private dokumentyAsyncClass = "Gordic.AdmIsl.Server.LoadDokumentyFunkcniMistoAsync";
        private presunAsyncClass = "Gordic.AdmIsl.Server.PresunFunkcniMistaSpisovyUzelAsync";

        private presunAsyncTaskId = "presunFunkcniMistaSpisoveUzly";
        private poctyDokumentuAsyncTaskId = "dokumentyFunkcnichMist";

        private funkcni_mista: Gordic.AdmIsl.Interface.GAdmFunkcniMistoListDto[];
        private ico: string;
        private formData: any;
        private defineData: {
            ixs_fun: string,
            ixs_fun_txt: string,
            ixs_ref_txt: string,
            ixs_su_old: string,
            ixs_su_old_txt: string,
            ixs_su_new: string,
            ixs_su_new_txt: string,
            pocetDokumenty?: number | null,
            checked: boolean,
            mode: boolean,
        }[];
        private grid: JQuery<HTMLElement>;

        onClose() {
            Async.GTaskManager.off(`.${ this.poctyDokumentuAsyncTaskId}`);
        }

        onContentReady() {
            this.initAsyncTaskPoctyDokumentu();
            this.initAsyncTaskPresun();
            this.createActions();
            this.createWizard();
        }

        private createActions() {
            this.actions.addRange({
                actOk: {
                    caption: "jres:33000243",
                    run: (ev, ctx) => {
                        this.actOk()
                    }
                }
            })
        }

        private createWizard() {
            new Gordic.Wizard().create({
                content: this
            }, {
                title: this.title,
                complete: (cnt, contentDiv, change) => {
                    cnt.close();
                },
                steps: [
                    {
                        caption: "jres:33000937", //RC 33000937 : Výběr dat
                        create: (cnt, contentDiv, change) => {
                            change.stepsEnable = [true, false]; 
                            this.createForm(contentDiv);
                        },
                        change: (cnt, contentDiv, change) => {
                            change.stepsEnable = [false, true];
                            let that = this;
                            return $.Deferred(function () {
                                let def = this;
                                let form = contentDiv.findForms();
                                if (form.gform("isValid") == true) {
                                    that.formData = {};
                                    form.findFields().gfield("model", "collect", that.formData);
                                    def.resolve();
                                } else
                                    def.reject();
                            })
                        }
                    }, 
                    {
                        caption: "jres:33000941", //RC 33000941 : Souhrn
                        create: (cnt, contentDiv, change) => {
                            change.stepsEnable = [false, true];
                            this.createGrid(contentDiv);
                            this.updateDataToGrid()
                        },
                        change: (cnt, contentDiv, change) => {
                            

                        },
                        primaryButton: GWizardPrimaryButtonEnum.custom,
                        buttons: [
                            {
                                action: this.actions.actOk,
                                primary: true,
                            }
                        ]
                    }
                ]
            })
        }

        private createForm(contentDiv: JQuery<HTMLElement>) {
            let form = new Gordic.Forms.Form()
                .addRow("jres:32131151").addField("gselectbox", Gordic.Prefabs.Select.ginsico(), {
                    name: "ico",
                    validators: [new Gordic.Validators.Required({ stoppping: true })],
                    flag: "required",
                    initialValue: { ico: this.ico },
                    disabled: true
                })
                .addRow("jres:33000093").addField("gselectbox", Gordic.Prefabs.Select.ginsfun(), {
                    name: "ixs_fun",
                    validators: [new Gordic.Validators.Required({ stoppping: true })],
                    flag: "required",
                    dropdown: true,
                    multi: true,
                    itemWidth: "",
                    model: "model.ixs_fun<=value.ixs_fun;model.ixs_fun_txt<=value.nazev;model.ixs_ref_txt<=value.nazev_ref;model.ixs_su_old<=value.ixs_su;model.ixs_su_old_txt<=value.nazev_su",
                    initialValue: this.funkcni_mista.map(funkcni_misto => ({ ixs_fun: funkcni_misto.ixs_fun })),
                    serverFilters: {
                        aktivita: null,
                        ico: new Gordic.Forms.Dependency("ico", "ico", true, false, this.element)
                    }
                })
                .addRow("jres:33000940").addField("gselectbox", Gordic.Prefabs.Select.ginspod(), { //RC 33000940 : Nový spisový uzel
                    name: "ixs_su",
                    model: "model.ixs_su_new<=value.ixs_su;model.ixs_su_new_txt<=value.nazev",
                    validators: [new Gordic.Validators.Required({ stoppping: true })],
                    flag: "required",
                    dropdown: true,
                    serverFilters: {
                        aktivita: null,
                        ico: new Gordic.Forms.Dependency("ico", "ico", true, false, this.element)
                    }
                })
                .addRow().addField("gcheck", {
                    name: "mode",
                    label: "jres:33000958", //RC 33000958 : Přesunout dokumenty rychleji (zatržením této možnosti při přesunu dojde k uzamčení celé databázové tabulky dokumentů, což znemožní ostatním uživatelům pracovat).
                    labelFromRow: "always"
                })
            $("<div>").appendTo(contentDiv).gform("createFrom", form);
        }

        private updateDataToGrid() {
            this.defineData = [];
            if (this.formData.ixs_fun && Array.isArray(this.formData.ixs_fun)) {
                for (var i = 0; i < this.formData.ixs_fun.length; i++) {
                    this.defineData.push({
                        ixs_fun: this.formData.ixs_fun[i],
                        ixs_fun_txt: this.formData.ixs_fun_txt[i],
                        ixs_ref_txt: this.formData.ixs_ref_txt[i],
                        ixs_su_old: this.formData.ixs_su_old[i],
                        ixs_su_old_txt: this.formData.ixs_su_old_txt[i],
                        ixs_su_new: this.formData.ixs_su_new,
                        ixs_su_new_txt: this.formData.ixs_su_new_txt,
                        mode: this.formData.mode,
                        checked: true
                    })
                }
                this.getDokumentyFunkcnichMist();
            }
        }

        private createGrid(contentDiv: JQuery<HTMLElement>) {
            this.grid = $("<div>").appendTo(contentDiv).gautofit({
                resizersOnTab: false
            }).ggrid({
                multi: true,
                rowsChecked: "checked",
                selection: (ev, obj) => {
                    this.actions.actOk?.update({ enabled: this.grid.ggrid("getSelection").length > 0 })
                },
                columns: new Gordic.Data.GridFormat()
                    .addTextColumn({
                        name: "ixs_fun_txt",
                        caption: "jres:32131155",
                    })
                    .addTextColumn({
                        name: "ixs_ref_txt",
                        caption: "jres:33000942", //RC 33000942 : Osoba zastávající funkci
                    })
                    .addTextColumn({
                        name: "ixs_su_old_txt",
                        caption: "jres:33000943", //RC 33000943 : Původní spisový uzel
                    })
                    .addTextColumn({
                        name: "ixs_su_new_txt",
                        caption: "jres:33000944" //RC 33000944 : Nový spisový uzel
                    })
                    .addNumberColumn({
                        name: "pocetDokumenty",
                        caption: "jres:33000947", //RC 33000947 : Dokumenty k přesunu
                        description: "jres:33000948" //RC 33000948 : Počet dokumentů, u kterých dojde ke změně vlastníka v důsledku změny spisového uzlu funkčního místa.
                    })
            })
        }

        private initAsyncTaskPoctyDokumentu() {
            if (Async.GTaskManager.getAllTasks().find(item => item.className == this.dokumentyAsyncClass) == undefined) {
                Async.GTaskManager.on(`init.${this.poctyDokumentuAsyncTaskId}`, this.dokumentyAsyncClass, (o) => {
                    this.beginOperation({ 
                        text: "jres:33000945", //RC 33000945 : Probíhá zjišťování počtu dokumentů jednotlivých funkčních míst.
                        id: this.poctyDokumentuAsyncTaskId
                    })
                })
                Async.GTaskManager.on(`change.${this.poctyDokumentuAsyncTaskId}`, this.dokumentyAsyncClass, (o) => {
                    if (o.state == 1) {
                        if (o.progress)
                            this.progressOperation({
                                id: this.poctyDokumentuAsyncTaskId,
                                text: o.progress.text,
                                progress: o.progress.current,
                                total: o.progress.total
                            })
                    }
                })
                Async.GTaskManager.on<Async.IGTaskProgress, Gordic.AdmIsl.Interface.GPocetDokumentuFunkcniMista>(`done.${this.poctyDokumentuAsyncTaskId}`, this.dokumentyAsyncClass, (o) => {
                    o.result.dokumentyFunkcniMista?.forEach(item => {
                        var index = this.defineData.findIndex(defineItem => defineItem.ixs_fun == item.ixs_fun);
                        if (index != -1)
                            this.defineData[index].pocetDokumenty = item.pocet_dokumentu
                    })
                    this.setDataToGrid(this.defineData);
                })
                Async.GTaskManager.on(`always.${this.poctyDokumentuAsyncTaskId}`, this.dokumentyAsyncClass, (o) => {
                    this.endOperation(this.poctyDokumentuAsyncTaskId);
                })
                Async.GTaskManager.on(`fail.${this.poctyDokumentuAsyncTaskId}`, this.dokumentyAsyncClass, (o) => {
                    this.setDataToGrid([]);
                    var not: IGNotificationOptions = {
                        title: "jres:33000936",
                        content: "jres:33000946", //RC 33000946 : Nepodařil se zjistit počet dokumentů jednotlivých fun. míst.
                        icon: "gi-uzel |gi-user g-state-text gi-stack-pos--rb gi-bgw",
                        state: "error",
                        id: `${this.poctyDokumentuAsyncTaskId}-fail`
                    }
                    this.notification("add", not);
                })
            }
        }

        private initAsyncTaskPresun() {
            if (Async.GTaskManager.getAllTasks().find(item => item.className == this.presunAsyncClass) == undefined) {
                Async.GTaskManager.on(`init.${this.presunAsyncTaskId}`, this.presunAsyncClass, (o) => {
                    var cnt = $.content();
                    cnt.notification("add", {
                        id: "presunFunkcniMistaSpisovyUzel",
                        title: "jres:33000953", //RC 33000953 : Přesun funkčních míst na spisové uzly
                        icon: "gi-uzel",
                        content: "jres:33000952" //RC 33000952 : Probíhá přesun funkčních míst na jiné spisové uzly
                    })
                })
                Async.GTaskManager.on(`change.${this.presunAsyncTaskId}`, this.presunAsyncClass, (o) => {
                    if (o.state == 1) {
                        if (o.progress) {
                            const cnt = $.content();
                            const not = cnt.notification("findById", "presunFunkcniMistaSpisovyUzel")
                            not?.update({ progress: o.progress as Required<Gordic.Async.IGTaskProgress> });
                        }
                    }
                })
                Async.GTaskManager.on<Async.IGTaskProgress, Gordic.AdmIsl.Interface.GPresunFunkcniMistoSpisovyUzelDto>(`done.${this.presunAsyncTaskId}`, this.presunAsyncClass, (o) => {
                    const cnt = $.content();
                    cnt.notification("remove", "presunFunkcniMistaSpisovyUzel");
                    const polozkyCount = o.result.polozky?.length;
                    const ok = o.result?.polozky?.filter((obj) => (obj as any).result == 0).length;
                    const resultObj = o.result as any;
                    resultObj.message = "jres:33000954".format(ok, polozkyCount) //RC 33000954 : Úspěšně přesunuto: {0} z {1}. Klikněte pro podrobnosti.
                    cnt.notification("add", {
                        id: "presunFunkcniMistaSpisovyUzelResult",
                        title: "jres:33000953",
                        icon: "gi-uzel",
                        content: resultObj,
                        state: (ok == polozkyCount) ? "success" : (ok == 0 ? "error" : "info"),
                        shortTemplate: "<span>{message}</span>",
                        defaultAction: new GAction({
                            name: "presunFunkcniMistoSpisovyUzelResult",
                            run: (ev, ctx) => {
                                $.content().dialogs.showModalWindow([Gordic.Adm.WebControls.DialogAdmFunkcniMistoSpisovyUzelResult, { result: o.result }], null, "jres:33000957", 700, 500) //RC 33000957 : Výsledek přesunu funkčních míst na spisové uzly
                            }
                        })
                    })
                })
                Async.GTaskManager.on(`fail.${this.presunAsyncTaskId}`, this.presunAsyncClass, () => {
                    const cnt = $.content();
                    cnt.notification("add", {
                        id: "presunFunkcniMistaSpisovyUzelResult",
                        title: "jres:33000953",
                        icon: "gi-uzel",
                        content: "jres:33000960", //RC 33000960 : Přesun funkčních míst na spisové uzly se nezdařil. Podrobnosti naleznete v logu aplikace.
                        state: "error"
                    })
                })
                Async.GTaskManager.on(`always.${this.presunAsyncTaskId}`, this.presunAsyncClass, () => {
                    Async.GTaskManager.off(`.${this.presunAsyncTaskId}`);
                })
            }
        }

        private setDataToGrid(data: any[]) {
            this.grid.ggrid("setData", data);
        }

        private getDokumentyFunkcnichMist() {
            Gordic.Async.GTaskManager.start(this.dokumentyAsyncClass, {
                dokumentyFunkcniMista: this.defineData.map(item => ({ ixs_fun: item.ixs_fun }))
            }, { clearOnFinish: true, autoClean: true })
        }

        private startPresun(gridData: any[]) {
            Gordic.Async.GTaskManager.start(this.presunAsyncClass, {
                polozky: gridData
            }, { clearOnFinish: true, autoClean: true })
        }

        private actOk() {
            let gridData = this.grid.ggrid("getSelection");
            if (gridData.length == 0) {
                this.dialogs.error("jres:32000124", "jres:33000951"); //RC 33000951 : Nejsou vybrána data k uložení!
            } else {
                this.dialogs.confirmDangerous("jres:33000949", "jres:33000950").on("yes", () => { //RC 33000950 : Opravdu si přejete přesunout vybraná funkční místa, na jiný spisový uzel. Tato akce bude vyžadovat i přesun dokumentů spojených s těmito funkčními místy, proto může velmi dlouho trvat.
                    this.startPresun(gridData);
                    this.close();
                })
            }
        }
    }
}